import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'fi-more-menu-mobile-dialog-handler',
    template: `
        <ng-template #moreMenuMobileDialog>
          <div class="fi-more-menu-dialog">
            @for (item of settings.ListItems; track item) {
              <a
                href
                (click)="onItemClick(item)"
                [ngClass]="{ disabled: item.isDisabled() }"
                >{{ item.label }}</a
                >
              }
            </div>
          </ng-template>
        `,
    standalone: false,
})
export class MoreMenuMobileDialogHandlerComponent implements OnInit {
    @Input() settings;
    @ViewChild('moreMenuMobileDialog', { static: true }) moreMenuMobileDialog: TemplateRef<any>;
    private dialogResult: MatDialogRef<any>;

    constructor(private fiDialogsService: FiDialogsService) {}

    ngOnInit() {
        this.dialogResult = this.fiDialogsService.open(this.moreMenuMobileDialog, {
            width: '400px',
        });
        this.dialogResult.afterClosed().subscribe(() => (this.settings.MobileMoreOpened = false));
    }

    onItemClick(item) {
        item.action();
        this.dialogResult.close(true);
        return false;
    }
}
